<template>
  <div class="wrapper">
    <p class="title">Edit Company Name</p>
    <div class="content">
      <!-- current name -->
      <div class="input-wrapper current-name">
        <label for="" class="label">Current name:</label>
        <div class="d-flex">
          <p class="text-value mr-1">
            {{ getCompanyName ? getCompanyName : "No name" }}
          </p>
        </div>
      </div>
      <!-- full name  -->
      <div class="full-name">
        <div class="input-wrapper">
          <label for="" class="label">New name:</label>
          <div
            class="form-group m-d-gruop mr-3"
            :class="$v.form.company.$error && 'invalid-value'"
          >
            <b-form-input v-model="form.company" type="text" required />
            <label>Company Name</label>
          </div>
        </div>
        <!-- err  -->
        <div class="err-wrapper">
          <div v-if="submitted && !$v.form.company.required">
            <span class="error-value">Required Company Name</span>
          </div>
          <div class="err-wrappe" v-if="submitted && !$v.form.company.maxLength">
            <span class="error-value">Maximum 255 characters</span>
          </div>
        </div>
      </div>
    </div>
    <!-- action btns  -->
    <hr class="h-line" />
    <div class="action-btns">
      <button
        class="submit-btn btn btn-primary"
        size="md"
        @click="onSubmit"
        :disabled="getLoading || !form.company"
      >
        <i
          v-if="getLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
        ></i>
        <span v-else>Update</span>
      </button>
      <button
        class="btn btn-outline-danger"
        @click="$bvModal.hide('companyName')"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import { required , maxLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["loggedInUser"],
  data() {
    return {
      submitted: false,
      current: {
        company_name: null,
      },
      form: {
        id: null,
        company: null,
      },
    };
  },
  validations: {
    form: {
      company: { 
        required , 
        maxLength: maxLength(255), 
      },
    },
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("companyName");
    },
  },
  computed: {
    ...mapGetters("user", [
      "getLoading",
      "getModalState",
      "getUserData",
      "getCompanyName",
    ]),
  },
  methods: {
    ...mapActions("user", ["editCompanyName", "resetState", "resetState"]),
    onSubmit() {
      this.submitted = true;
      this.$v.$touch();
      this.$v.$error ? "" : this.updateUser();
    },
    updateUser() {
      this.editCompanyName(this.form);
    },
  },
  beforeMount() {
    const { getUserData, resetState } = this;
    resetState();
    this.current.company_name =
      getUserData && getUserData.company_name
        ? getUserData.company_name
        : "No name";
    this.form.id = getUserData.id;
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .current-name {
    margin-bottom: 29px;
    .label {
      margin-bottom: 0;
      margin-right: 30px;
    }
    .text-value {
      margin-bottom: 0;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.87);
      opacity: 0.8;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 15em;
    }
  }
  .full-name {
    margin-bottom: 23px;
  }
  .err-wrapper {
    padding-left: 155px;
    span {
      margin-top: 0;
    }
  }
}
</style>
